import * as utils from 'Utils';


export function getReperksWidgetPayloads(successCallback, errorCallback, widgetId, qs={}) {
  utils.getRq({
    "url": utils.buildUrl(`reperks-widget-payloads/${widgetId}`, qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

export function getReperksMemberActivities(successCallback, errorCallback, memberId, qs={}) {
  utils.getRq({
    "url": utils.buildUrl(`reperks-members/${memberId}/activities`, qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

export function postEditMemberBirthday(successCallback, errorCallback, memberId, data) {
  utils.postRq({
    "url": utils.buildUrl(`reperks-members/${memberId}/edit-birthday`),
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}

export function postRedeemReperksReward(successCallback, errorCallback, rewardId, data) {
  utils.postRq({
    "url": utils.buildUrl(`reperks-rewards/${rewardId}/redeem`),
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}

export function postAwardLinkPoints(successCallback, errorCallback, ruleId, data) {
  utils.postRq({
    "url": utils.buildUrl(`reperks-activity-rules/${ruleId}/award-link-points`),
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}


